import axios from "@/plugins/axios.js";

export default {
  //新增简历
  applyPost(param) {
    return axios.post("/Grzx/addGrjl", param);
  },
  //查询简历
  queryGrjl(param) {
    return axios.post("/Grzx/queryGrjl", param);
  },
  //修改简历
  modifyPost(param) {
    return axios.post("/Grzx/modifyGrjl", param);
  },
  //删除简历
  delGrjl(param) {
    return axios.post("/Grzx/deleteGrjl", param);
  },
  //修改个人信息
  modifyGrxx(param) {
    return axios.post("/Grzx/modifyGrxx", param);
  },
  //发送手机验证码
  sendCode(param) {
    return axios.post("/User/sendYzm", param);
  },
  //查询报名信息
  queryBmxx(param) {
    return axios.post("/Grzx/queryBmxx", param);
  },
  //修改报名信息
  modifyBmxx(param) {
    return axios.post("/Grzx/modifyBmxx", param);
  },
  //删除报名信息
  deleteBmxx(param) {
    return axios.post("/Grzx/deleteBmxx", param);
  },
  //查询招聘岗位
  queryZpgwInfo(param) {
    return axios.post("/Lov/queryZpgwInfo", param);
  },
  //查询招聘专业
  queryZpzyInfo(param) {
    return axios.post("/Lov/queryZpzyInfo", param);
  },
  //文件上传
  uploadFile(param) {
    return axios.post("/file/uploadFile", param, {
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8"
      }
    });
  },
  //文件删除
  delFile(param) {
    return axios.post("/file/delFile", param);
  },
  //打印报名表
  doPrintBmdjb(param) {
    return axios.post("/Grzx/doPrintBmdjb", param);
  },
  //更新报名附件
  updateBmxxFileInfo(param) {
    return axios.post("/Grzx/updateBmxxFileInfo", param);
  },
  //文件上传
  setBMISection(param) {
    return axios.post("/file/setBMISection", param, {
      headers: {
        "Content-Type": "multipart/form-data;charset=UTF-8"
      }
    });
  },
  //修改报名信息
  modifyShhzpBmxx(param) {
    return axios.post("/Grzx/modifyShhzpBmxx", param);
  },
};
